import { render, staticRenderFns } from "./CsimSchemaPeriodFormList.vue?vue&type=template&id=07ed7358&scoped=true"
import script from "./CsimSchemaPeriodFormList.vue?vue&type=script&lang=js"
export * from "./CsimSchemaPeriodFormList.vue?vue&type=script&lang=js"
import style0 from "./CsimSchemaPeriodFormList.vue?vue&type=style&index=0&id=07ed7358&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed7358",
  null
  
)

export default component.exports